// Address geocoding helper that queries the server /api/address endpoint
// or parses direct coordinate input (e.g. "55.33, 11.96").
export async function lookupAddressCoordinates(
  addressOrCoords: string,
): Promise<{ center: [number, number]; resolvedText?: string } | null> {
  const raw = addressOrCoords.trim();
  if (!raw) return null;

  // Direct coordinate match: "55.3345, 11.9836" or "55.3345 11.9836"
  const coordMatch = raw.match(/^([0-9]{1,2}(?:\.[0-9]+)?)[,\s]+([0-9]{1,2}(?:\.[0-9]+)?)$/);
  if (coordMatch) {
    const lat = parseFloat(coordMatch[1]);
    const lng = parseFloat(coordMatch[2]);
    if (lat >= 54 && lat <= 58 && lng >= 7 && lng <= 16) {
      return { center: [lng, lat], resolvedText: `GPS: ${lat.toFixed(5)}, ${lng.toFixed(5)}` };
    }
  }

  try {
    const response = await fetch(`/api/address?q=${encodeURIComponent(raw)}`);
    if (!response.ok) return null;
    const data = await response.json();
    if (Array.isArray(data.results) && data.results.length > 0) {
      const first = data.results[0];
      if (first?.data && Number.isFinite(first.data.x) && Number.isFinite(first.data.y)) {
        return {
          center: [first.data.x, first.data.y], // [lng, lat]
          resolvedText: first.tekst,
        };
      }
    }
  } catch {
    // Network / API unavailable
  }

  return null;
}
